<template>
  <admin-confirm-dialog
    :item="item"
    title="Kullanıcıyı sil"
    description="{name} kullanıcısını silmek istediğinize emin misiniz?"
    confirm-text="Kullanıcıyı Sil"
    :save="save"
    :close="close"
  ></admin-confirm-dialog>
</template>

<script>
import AdminConfirmDialog from '@/components/admin/AdminConfirmDialog.vue'

export default {
  components: {
    AdminConfirmDialog,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    save: {
      type: Function,
      default: undefined,
    },
    close: {
      type: Function,
      default: undefined,
    },
  },
}
</script>
